import { isEmpty, pathOr } from 'ramda';

export const getDda = (data = {}) => {
  const accounts = pathOr([], ['directDepositAccounts', 'data'], data);
  const checkingAccounts = accounts.filter((a) => a.type === 'CHECKING');
  return isEmpty(checkingAccounts) ? null : checkingAccounts[0] || {};
};
